<template>
  <div>
    <v-card outlined tile style="border: 2px solid #00475a" class="px-5">
      <v-system-bar height="30" color="#fff" class="px-0">
        <span></span>
        <v-spacer></v-spacer>
        <v-icon size="32" class="pt-5" @click="close">mdi-close</v-icon>
      </v-system-bar>
      <v-card-title>
        <h3>
          {{ $t("message.magic.createAlert", { value: "default" }) }}
        </h3></v-card-title
      >
      <v-card-text>
        <v-alert dense text :type="type" v-show="show">{{ message }}</v-alert>
        <v-form ref="signalForm" v-model="valid" lazy-validation>
          <v-row v-if="hasHotline">
            <v-col md="4"></v-col>
            <v-col>
              <v-switch v-model="hotline" :label="this.$t('message.magic.hotline')" />
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col md="4" class="label-field">
              {{ $t("message.magic.title", { value: "default" }) }}:
            </v-col>
            <v-col>
              <v-text-field
                dense
                outlined
                :rules="titleRules"
                hide-details="auto"
                v-model="serviceRequest.description"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col md="4" class="label-field">
              {{ $t("message.magic.description", { value: "default" }) }}:
            </v-col>
            <v-col>
              <v-textarea
                auto-grow
                rows="3"
                dense
                hide-details="auto"
                outlined
                :rules="descRules"
                required
                v-model="serviceRequest.description_longdescription"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col md="4" class="label-field"
              >{{ $t("message.infoloc.locomotive", { value: "default" }) }}:
            </v-col>
            <v-col md="5">
              <v-select
                dense
                outlined
                required
                :rules="locoRules"
                hide-details="auto"
                v-model="serviceRequest.assetnum"
                :items="assets"
                item-value="asset"
                item-text="asset"
              ></v-select>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col md="4" class="label-field">
              {{ $t("message.magic.date", { value: "default" }) }}:
            </v-col>
            <v-col md="5">
              <date-picker
                style="width: 100%"
                dense
                outlined
                hide-details="auto"
                type="datetime"
                v-model="serviceRequest.reportdate"
              ></date-picker>
            </v-col>
          </v-row>

          <v-row class="mt-0">
            <v-col md="4" class="label-field">
              {{ $t("message.magic.priority", { value: "default" }) }}:
            </v-col>
            <v-col md="5">
              <v-select
                dense
                outlined
                :rules="priorityRules"
                hide-details="auto"
                required
                class="mt-0"
                v-model="serviceRequest.reportedpriority"
                :items="priorities"
                item-value="value"
                item-text="description"
              ></v-select>
            </v-col>
          </v-row>

          <v-row class="mt-0">
            <v-col md="4" class="label-field">
              {{ $t("message.magic.addFile", { value: "default" }) }}:
            </v-col>
            <v-col>
              <v-file-input
                label=""
                multiple
                outlined
                counter
                :show-size="1000"
                v-model="files"
                dense
                append-icon="mdi-upload-outline"
                prepend-icon=""
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip color="#00475a" dark label small v-if="index < 1">
                    {{ text }}
                  </v-chip>
                  <span
                    v-else-if="index === 1"
                    class="text-overline grey--text text--darken-3 mx-2"
                  >
                    +{{ files.length - 1 }} File(s)
                  </span>
                </template>
              </v-file-input>
            </v-col>
          </v-row>
          <v-row class="mt-6 mb-3 d-flex justify-end">
            <v-btn class="mr-2" color="#CCD2D5" @click="clearData" dark>{{
              $t("message.button.cancel", { value: "default" })
            }}</v-btn>
            <v-btn color="#00475A" dark @click="validate" :loading="loading">{{
              $t("message.button.submit", { value: "default" })
            }}</v-btn>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import MaximoService from "@/services/MaximoService";
import { parseDatetimelocal } from "../shared/DateHelper";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
export default {
  props: {
    assets: {},
    customer: {},
    user: {},
    hasHotline: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DatePicker,
  },
  data() {
    return {
      type: "info",
      message: "",
      show: false,
      files: [],
      file: null,
      loading: false,
      doclinks: [],
      priorities: [],
      locations: [],
      serviceRequest: {
        description: "",
        description_longdescription: "",
        pluspcustomer: this.customer,
        assetnum: "",
        doclinks: [],
        reportedpriority: null,
        reportedby: "",
      },
      valid: true,
      locoRules: [(v) => !!v || "Locomotive is required"],
      titleRules: [(v) => !!v || "Title is required"],
      descRules: [
        (v) => !!v || "Description is required",
        (v) =>
          (v && v.length >= 10) ||
          "Description must be more than 10 characters",
      ],
      typeRules: [(v) => !!v || "type is required"],
      priorityRules: [(v) => !!v || "Priority is required"],
      locotionRules: [(v) => !!v || "Location is required"],
      hotline: false,
    };
  },
  methods: {
    validate() {
      if (this.$refs.signalForm.validate()) {
        this.loading = true;
        if (this.files.length == 0) {
          this.serviceRequest.reportdate = parseDatetimelocal(
            this.serviceRequest.reportdate
          );
          this.serviceRequest.reportedby = this.user.internal
            ? this.user.mail
            : "";
          this.serviceRequest.nosendmail = this.user.mail;
          // add cx_type = HOT to payload if checked
          if (this.hotline) {
            this.serviceRequest.cx_type = 'HOT';
          }
          this.saveSR(this.serviceRequest);
        } else {
          for (let i = 0; i < this.files.length; i++) {
            if (i == this.files.length - 1) {
              this.readFile(this.files[i], true);
            } else {
              this.readFile(this.files[i], false);
            }
          }
        }
      }
    },

    clearData() {
      this.$refs.signalForm.reset();
      this.show = false;
      this.message = "";
    },

    readFile(file, send) {
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.serviceRequest.doclinks.push({
          urltype: "FILE",
          urlname: file.name,
          documentdata: reader.result.replace("data:", "").replace(/^.+,/, ""),
        });
        if (send) {
         
          this.serviceRequest.reportedby = this.user.internal
            ? this.user.mail
            : "";
          this.serviceRequest.nosendmail = this.user.mail;
          this.saveSR(this.serviceRequest);
        }
      });

      reader.readAsDataURL(file);
    },

    getUserMail(user) {
      if (user.internal) {
        return user.mail;
      }
      return "";
    },
    close() {
      this.clearData();
      this.$emit("srClose", this.type);
    },

    loadPriority() {
      MaximoService.loadPriority().then((response) => {
        this.priorities = response.data;
      });
    },

    loadLocations() {
      MaximoService.loadLocations().then((response) => {
        this.locations = response.data;
      });
    },

    saveSR(payload) {
      MaximoService.saveSR(payload)
        .then(() => {
          //this.emitAction("ok");
          this.message = this.$t("message.magic.success", { value: "default" });
          this.type = "success";
          this.show = true;
          this.loading = false;
          this.$refs.signalForm.reset();
        })
        .catch(() => {
          this.message = this.$t("message.magic.error", { value: "default" });
          this.type = "error";
          this.show = true;
          this.loading = false;
        });
    },
  },

  mounted() {
    this.loadPriority();
    this.loadLocations();
  },
};
</script>

<style scoped>
.label-field {
  color: #00475a;
  font: normal normal bold 16px/19px Calibri;
}
</style>
